/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const ReplyStrokeIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M4.03557 10.6H13.6356C15.8758 10.6 16.9959 10.6 17.8515 11.0359C18.6042 11.4194 19.2161 12.0313 19.5996 12.784C20.0356 13.6396 20.0356 14.7597 20.0356 17M8.47488 15.282L4.35858 11.1656C4.16057 10.9676 4.06157 10.8686 4.02447 10.7545C3.99184 10.654 3.99184 10.5459 4.02447 10.4455C4.06157 10.3313 4.16057 10.2323 4.35858 10.0343L8.47488 5.91797"
          strokeLinecap="round"
        />
      </svg>
    </Icon>
  );
});

export { ReplyStrokeIcon };
